import { useTranslation, Trans } from 'react-i18next';
import { Grid, Link, Typography } from '@mui/material';
import { namespaces } from '@zenown-insurance/i18n-service';
import ReturnButton from '../return-button/ReturnButton';
import RVLogo from '../../assets/insurance/RV.png';
import RVLogo2 from '../../assets/insurance/RV@2x.png';
import RVLogo3 from '../../assets/insurance/RV@3x.png';
import { useEffect, useState } from 'react';
import CookiesSheet from './CookiesSheet';

export interface PolicyPageProps {
  onClose: () => void;
}

export function PolicyPage(props: any) {
  const { onClose, trackEvent } = props;

  const { t: tupload } = useTranslation(namespaces.pages.uplaodPage);
  const t = (key: string) => tupload('policyPage.' + key);
  const { t: common } = useTranslation(namespaces.common);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent({ event: 'Page Visit', action: 'Privacy Policy' });
  }, []);
  const renderSections = () => {
    const sectionTexts = PolicyParagraps.map(
      (paragraph: { title: string; description: string }, index: number) => {
        return (
          <Grid item key={index + ''}>
            <Typography sx={{ marginBottom: '20px' }} variant="h3">
              {index + 1 + '.  ' + t('paragraphs.' + paragraph.title)}
            </Typography>
            <Typography variant="subtitle1">
              <Trans
                i18nKey={'paragraphs.' + paragraph.description}
                t={t}
                components={{
                  link: (
                    <a
                      style={{
                        color: '#0179FF !important',
                        cursor: 'pointer',
                      }}
                      href={
                        t('paragraphs.' + paragraph.description)?.includes('@')
                          ? 'mailto:' + t('paragraphs.' + paragraph.description)
                          : '' + t('paragraphs.' + paragraph.description)
                      }
                      color="#0179FF"
                    >
                      {t('paragraphs.' + paragraph.description)}
                    </a>
                  ),
                  br: <br />,
                  tab: <p>{'    '}</p>,
                  underline: (
                    <span style={{ textDecoration: 'underline' }}>
                      {t('paragraphs.' + paragraph.description)}
                    </span>
                  ),
                  strong: (
                    <strong>{t('paragraphs.' + paragraph.description)}</strong>
                  ),
                  cookies: (
                    <div
                      style={{
                        color: '#0179FF',
                        textAlign: 'center',
                        marginInline: 'auto',
                        cursor: 'pointer',
                        width: '100%',
                      }}
                      onClick={() => {
                        console.log('open cookies');
                        setOpen(true);
                      }}
                    >
                      sssss
                      <br />
                      <span
                        style={{
                          color: '#0179FF',
                          textAlign: 'center',
                          marginInline: 'auto',
                          cursor: 'pointer',
                          width: '100%',
                        }}
                        color="#0179FF"
                        onClick={() => {
                          console.log('open cookies');
                          setOpen(true);
                        }}
                      >
                        {t('paragraphs.' + paragraph.description)}
                      </span>
                    </div>
                  ),

                  email: (
                    <a
                      style={{ color: '#0179FF' }}
                      color="#0179FF"
                      href={
                        t('paragraphs.' + paragraph.description)?.includes('@')
                          ? 'mailto:' + t('paragraphs.' + paragraph.description)
                          : '' + t('paragraphs.' + paragraph.description)
                      }
                    >
                      {t('paragraphs.' + paragraph.description)}
                    </a>
                  ),
                }}
              />
            </Typography>
          </Grid>
        );
      }
    );

    return sectionTexts;
  };

  return (
    <div style={{ position: 'relative' }}>
      {open && <CookiesSheet {...{ open, setOpen }} />}

      <ReturnButton
        onClick={() => {
          trackEvent({
            event: 'Button click',
            action: 'Back',
          });
          onClose();
        }}
      />
      {false && (
        <img
          src={RVLogo}
          srcSet={`${RVLogo} 1x, ${RVLogo2} 2x, ${RVLogo3} 3x`}
          style={{
            height: '22px',
            width: '56px',
            right: '0',
            top: '-45px',
            position: 'absolute',
          }}
          alt="RV Logo"
        />
      )}

      <div
        style={{
          height: 'auto',
          minWidth: '330px',
          overflowY: 'scroll',
          marginTop: '88px',
          marginBottom: '88px',
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ gap: '30px' }}
        >
          <Grid
            item
            container
            direction="column"
            justifyContent="space-between"
            spacing={1.5}
            alignItems="flex-start"
          >
            <Grid item>
              <Typography variant="h1" sx={{ marginBottom: '20px' }}>
                {t('title')}
              </Typography>
              <Typography variant="subtitle1">
                <Trans
                  i18nKey="description"
                  t={t}
                  components={{
                    link: (
                      <a
                        href={
                          t('description')?.includes('@')
                            ? 'mailto:' + t('description')
                            : '' + t('description')
                        }
                        style={{
                          color: '#0179FF !important',
                          cursor: 'pointer',
                        }}
                        color="#0179FF"
                      >
                        {t('description')}
                      </a>
                    ),
                    newLine: <br />,
                    tab: <p>{'    '}</p>,
                    underline: (
                      <span style={{ textDecoration: 'underline' }}>
                        {t('description')}
                      </span>
                    ),
                    strong: <strong>{t('description')}</strong>,
                    email: (
                      <a
                        style={{ color: '#383A49' }}
                        color="#383A49"
                        href={'mailto:' + t('description')}
                      >
                        {t('description')}
                      </a>
                    ),
                  }}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="column"
            justifyContent="space-around"
            sx={{ gap: '30px' }}
            alignItems="flex-start"
          >
            {renderSections()}
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default PolicyPage;
const PolicyParagraps = [
  {
    title: '1.title',
    description: '1.description',
  },
  {
    title: '2.title',
    description: '2.description',
  },
  {
    title: '3.title',
    description: '3.description',
  },
  {
    title: '4.title',
    description: '4.description',
  },
  {
    title: '5.title',
    description: '5.description',
  },
  {
    title: '6.title',
    description: '6.description',
  },
  {
    title: '7.title',
    description: '7.description',
  },
  {
    title: '8.title',
    description: '8.description',
  },
  {
    title: '9.title',
    description: '9.description',
  },
  {
    title: '10.title',
    description: '10.description',
  },
  {
    title: '11.title',
    description: '11.description',
  },
  {
    title: '12.title',
    description: '12.description',
  },
];
